import { ERezervasyonDurumID } from "@shared/models";

export interface IRezervasyonlar extends IMekanlar {
    mekanRezervasyonID: number;
    rezervasyonYapan: string;
    durumID: ERezervasyonDurumID;
    durum: string
    baslangicZamani: Date;
    bitisZamani: Date;
    aciklama: string;
}

export interface IMekanlar {
    mekanID: number;
    mekanAdi: string;
}

export class RezervasyonlarFilter {
    date: string;
    durumID: ERezervasyonDurumID;
    mekanID: number;
}